import { render, staticRenderFns } from "./vuecommxds4.vue?vue&type=template&id=65e7876a&scoped=true"
import script from "./vuecommxds4.vue?vue&type=script&lang=js"
export * from "./vuecommxds4.vue?vue&type=script&lang=js"
import style0 from "./vuecommxds4.vue?vue&type=style&index=0&id=65e7876a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7876a",
  null
  
)

export default component.exports